// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Spinner_spinnerContainer__eOHKl","spinner":"Spinner_spinner__lKhUz","rotate":"Spinner_rotate__U1SVQ","prixClipFix":"Spinner_prixClipFix__jO7Ux"};